import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  createLoadByIdReducer, createLoadListReducerWithBegin, createOperationStateReducer, initialStateCRUD,
} from '../../utils/getCrudConfig';
import { MODULE_NAME } from './constants';
import {
  CREATE, DELETE_BY_ID, LOAD_BY_ID, LOAD_LIST, UPDATE,
} from '../../configs/actionNames';
import { USER_MODULE } from '../../configs/moduleNames';

const initialState = {
  ...initialStateCRUD,
  loadingStats: false,
  userList: [],
  loadingUserList: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(MODULE_NAME + LOAD_LIST, 'userList', 'loadingUserList'),
  ...createLoadByIdReducer(MODULE_NAME + LOAD_BY_ID, 'current', 'loadingCurrent'),
  ...createOperationStateReducer(MODULE_NAME + CREATE, 'loadingCreate'),
  ...createOperationStateReducer(MODULE_NAME + DELETE_BY_ID, 'loadingDelete'),
  ...createOperationStateReducer(MODULE_NAME + UPDATE, 'loadingUpdate'),
}, initialState);

export default reducer;

export const getUsersData = createSelector(
  [state => state[USER_MODULE]],
  state => {
    const {
      userList,
      loadingUserList,
    } = state;
    return {
      userList,
      loadingUserList,
    };
  },
);
